import React from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import {sendRegMed} from "../../store/actions/customUI";
import UrDt from "../CustomLogic/UrDt";
import AdmDt from "../CustomLogic/AdmDt";

const ModalSelectRegMedMultiple = () => {
    const {show, admission, customUI, sets} = useSelector(state => state.modal.selectRegMedSet);
    const dispatch = useDispatch();
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_SELECT_REG_MED_SET_HIDE});

    const handleSelectSet = (set) => {
        hideModal();
        dispatch({
            type: actionTypes.MODAL_CONFIRM_ADMISSION_ACTION_SHOW,
            admission: admission,
            actionLabel: `Send ${set.title}`,
            actionDispatchable: sendRegMed(admission, customUI, set.id)
        });
    };

    const renderSets = () => {
        return sets.map((set, index) => (
            <tr key={set.id}>
                <td>{set.title}</td>
                <td>{set.admissionDocumentTypes && set.admissionDocumentTypes.join(', ')}</td>
                <td>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleSelectSet(set)}
                    >
                        Select
                    </button>
                </td>
            </tr>
        ));
    };

    const renderModal = () => {
        return (
            <div className="modal-dialog" role="document" ref={ref}>
                <div className="modal-content">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body">
                        <h3>Select document set for {admission.title} {admission.surname}, {admission.name}</h3>
                        <dl className="person-list mb-3">
                            <UrDt admission={admission}/>
                            <AdmDt admission={admission}/>
                        </dl>
                        <table className="table" cellSpacing="0" width="100%">
                            <thead>
                            <tr>
                                <th><strong className="title">Document Set</strong></th>
                                <th><strong className="title">Document Types</strong></th>
                                <th><strong className="title">Action</strong></th>
                            </tr>
                            </thead>
                            <tbody>
                            {renderSets()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="selectRegMedSetModal" tabIndex="-1" role="dialog"
                 aria-labelledby="selectRegMedSetModalLabel" aria-modal="true">
                {show && renderModal()}
            </div>
        </>
    );
};

export default ModalSelectRegMedMultiple;
